<template>
    <li>
        <div class="title"><span>カテゴリ</span></div>
        <div class="detail">

            <ul class="list_category">

                <li class="lv1" v-for="(categoriyLv1, categoriyLv1_index) in getCategoriyLv1" v-bind:key="categoriyLv1_index">
                    <div class="md_label"><span>{{categoriyLv1.name}}</span></div>
                    <ul class="lv2">
                        <template v-if="categoriyLv1.id == 1 " v-for="(categoriyLv2,categoriyLv2_index) in getCategoriyLv2" v-bind:key="categoriyLv2_index">
                            <template v-if="categoriyLv1.id == categoriyLv2.first_category_id">
                                <li style="padding-bottom: 1rem;">
                                    <span>
                                        {{categoriyLv2.name}}
                                        <ul class="lv3">
                                            <template v-for="(categoriyLv3,categoriyLv3_index) in getCategoriyLv3" v-bind:key="categoriyLv3_index">
                                                <template v-if="categoriyLv2.id == categoriyLv3.second_category_id">
                                                    <li>
                                                        <span>
                                                            {{categoriyLv3.name}}
                                                        </span>
                                                    </li>
                                                </template>
                                            </template>
                                        </ul>
                                    </span>
                                </li>
                            </template>
                        </template>
                        <li v-if="categoriyLv1.id != 1 " v-for="(categoriyLv2,categoriyLv2_index) in getCategoriyLv2" v-bind:key="categoriyLv2_index">
                            <template v-if="categoriyLv1.id == categoriyLv2.first_category_id">
                                <span>
                                    {{categoriyLv2.name}}
                                </span>
                            </template>
                        </li>
                    </ul>
                </li>
            </ul>
        </div>
    </li>
</template>

<script>
    export default {
        computed: {
            getCategoriyLv1: function() {
                var items = [];

                var categoriyLv1s = this.$store.state.register.form.categoriyLv1;
                var categoriyLv2s = this.$store.state.register.form.categoriyLv2;
                var categoriyLv3s = this.$store.state.register.form.categoriyLv3;

                categoriyLv1s.forEach(function(categoriyLv1, categoriyLv1_index){
                    if (categoriyLv1.id == 1) {
                        categoriyLv2s.forEach(function(categoriyLv2, categoriyLv2_index){

                            // アパレルのその他のみ第三階層がないので表示
                            if (categoriyLv2.id == 8) {
                                items.push(categoriyLv1)
                            }

                            if (categoriyLv1.id == categoriyLv2.first_category_id) {
                                categoriyLv3s.forEach(function(categoriyLv3, categoriyLv3_index){
                                    if (categoriyLv2.id == categoriyLv3.second_category_id) {
                                        items.push(categoriyLv1)
                                    }
                                });
                            }
                        });
                    } else {
                        categoriyLv2s.forEach(function(categoriyLv2, categoriyLv2_index){
                            if (categoriyLv1.id == categoriyLv2.first_category_id) {
                                items.push(categoriyLv1)
                            }
                        });
                    }
                    
                });
                // 重複をなくす
                const removeDuplicateValues = ([...array]) => {
                    return array.filter((value, index, self) => self.indexOf(value) === index);
                }
                items = removeDuplicateValues(items);
                this.$store.state.register.form.Lv1 = items;
                return items;
            },
            getCategoriyLv2: function() {
                var items = [];

                var categoriyLv2s = this.$store.state.register.form.categoriyLv2;
                var categoriyLv3s = this.$store.state.register.form.categoriyLv3;

                categoriyLv2s.forEach(function(categoriyLv2, categoriyLv2_index){
                    // アパレルのその他のみ第三階層がないので表示
                    if (categoriyLv2.id == 8) {
                        items.push(categoriyLv2)
                    }

                    if (categoriyLv2.first_category_id == 1){
                        categoriyLv3s.forEach(function(categoriyLv3, categoriyLv3_index){
                            if (categoriyLv2.id == categoriyLv3.second_category_id) {
                                items.push(categoriyLv2)
                            }
                        });
                    } else {
                        items.push(categoriyLv2)
                    }
                });
                // 重複をなくす
                const removeDuplicateValues = ([...array]) => {
                    return array.filter((value, index, self) => self.indexOf(value) === index);
                }
                items = removeDuplicateValues(items);
                this.$store.state.register.form.Lv2 = items;
                return items;
            },
            getCategoriyLv3: function() {
                this.$store.state.register.form.Lv3 = this.$store.state.register.form.categoriyLv3;
                return this.$store.state.register.form.categoriyLv3;
            },
        }
    }
</script>